import { render, staticRenderFns } from "./CompanyVerticalNavMenu.vue?vue&type=template&id=a10c183e&"
import script from "./CompanyVerticalNavMenu.vue?vue&type=script&lang=js&"
export * from "./CompanyVerticalNavMenu.vue?vue&type=script&lang=js&"
import style0 from "./CompanyVerticalNavMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports